import React from 'react';
import { Check, ShoppingCart, CreditCard, FileText, CheckCircle } from 'lucide-react';

const ProgressBar = ({ currentStep }) => {
  const steps = [
    { id: 'cart', label: 'Cart', icon: ShoppingCart },
    { id: 'checkout', label: 'Checkout', icon: FileText },
    { id: 'payment', label: 'Payment Method', icon: CreditCard },
    { id: 'thankyou', label: 'Thank You', icon: CheckCircle }
  ];

  const getCurrentStepIndex = () => {
    return steps.findIndex(step => step.id === currentStep);
  };

  const currentStepIndex = getCurrentStepIndex();

  return (
    <div className="bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-50 dark:from-slate-900 dark:via-blue-900 dark:to-indigo-900 border-b border-gray-200 dark:border-gray-700 py-6 sm:py-8">
      <div className="max-w-6xl mx-auto px-4 sm:px-8 lg:px-12 overflow-x-auto">
        <div className="flex items-center justify-between flex-nowrap gap-y-4 min-w-max">
          {steps.map((step, index) => {
            const Icon = step.icon;
            const isCompleted = index < currentStepIndex;
            const isCurrent = index === currentStepIndex;
            const isActive = index <= currentStepIndex;

            return (
              <div key={step.id} className="flex items-center shrink-0">
                <div className="flex flex-col items-center">
                  <div
                    className={`w-12 h-12 sm:w-16 sm:h-16 rounded-full flex items-center justify-center border-2 transition-all duration-500 shadow-lg ${
                      isCompleted
                        ? 'bg-gradient-to-br from-green-500 to-emerald-600 border-green-500 text-white shadow-glow'
                        : isCurrent
                        ? 'bg-gradient-to-br from-blue-500 to-purple-600 border-blue-500 text-white shadow-glow'
                        : 'bg-white/80 dark:bg-white/10 backdrop-blur-md border-gray-300 dark:border-gray-600 text-gray-400 dark:text-gray-500'
                    }`}
                  >
                    {isCompleted ? (
                      <Check className="w-6 h-6 sm:w-8 sm:h-8" />
                    ) : (
                      <Icon className="w-6 h-6 sm:w-8 sm:h-8" />
                    )}
                  </div>
                  <span
                    className={`text-xs sm:text-sm font-bold mt-2 sm:mt-3 transition-all duration-300 ${
                      isActive
                        ? 'text-blue-600 dark:text-blue-400'
                        : 'text-gray-500 dark:text-gray-400'
                    }`}
                  >
                    {step.label}
                  </span>
                </div>
                {index < steps.length - 1 && (
                  <div
                    className={`w-10 sm:w-24 h-1 mx-2 sm:mx-6 rounded-full transition-all duration-500 shrink-0 ${
                      isCompleted
                        ? 'bg-gradient-to-r from-green-500 to-emerald-600 shadow-lg'
                        : 'bg-gray-300 dark:bg-gray-600'
                    }`}
                  />
                )}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default ProgressBar; 